import { ClientDataService, IClientDataDoc } from '../../../../services/clientData.service'

export class PNProcedureServices extends ClientDataService {
  private PERT_NEG_PROCEDURE_OPTIONS = 'tb_nemsis3_procedures'

  async getPertNegativesProcedureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PERT_NEG_PROCEDURE_OPTIONS)
  }
}
